import {
  Autocomplete,
  FormControl,
  Paper,
  Popper,
  Select,
  styled,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { CircularProgress } from "@mui/material";
import { getReferentielDataFromServer } from "../general/AxiosReferencielInterceptor";
import { TurnedInNotRounded } from "@mui/icons-material";

const AppSelectInputApi = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState([]);
  const {
    name,
    label,
    error: errorProp,
    apiOptions,
    dataPath = "none",
    refactoResponse,
    startLoadingOn,
    deps,
    placeholder,
    startAdornment,
    onChange,
    multiple = false, // Default to false for backward compatibility
    value, // Add value prop to control the component
    initialValueId, // Add prop to set initial selection by ID
    ...rest
  } = props;

  useEffect(() => {
    if (errorProp) {
      setError(errorProp);
    }
  }, [errorProp]);

  useEffect(() => {
    const fetchResponse = async () => {
      if (typeof startLoadingOn !== "function" || startLoadingOn()) {
        setIsLoading(true);
        let body = { ...apiOptions.body };
        const response = await getReferentielDataFromServer(
          apiOptions.urlStatic || false,
          apiOptions.api,
          { ...body },
          apiOptions.method || "post"
        );
        if (response?.error) {
          setIsLoading(false);
          setError(response?.data?.message);
        } else {
          let responseBody = [];
          if (dataPath === "none") {
            responseBody = response;
          } else {
            const pathParts = dataPath.split(",");
            responseBody = pathParts.reduce(
              (acc, part) => acc?.[part],
              response
            );
          }
          const processedOptions = refactoResponse
            ? refactoResponse(responseBody)
            : responseBody.map((option) => {
                return {
                  id: option.id,
                  label: option.description,
                };
              });
          
          setOptions(processedOptions);
          
          // Auto-select option if initialValueId is provided and no value is currently set
          if (initialValueId && !value) {
            const initialOption = processedOptions.find(opt => opt.id === initialValueId);
            if (initialOption && onChange) {
              onChange(initialOption);
            }
          }
          
          setIsLoading(false);
        }
      }
    };
    fetchResponse();
  }, [name, deps, initialValueId]);

  return (
    <FormControl variant="standard" fullWidth>
      <Typography
        gutterBottom
        color="primary.main"
        variant="tsb5"
        style={{
          display: "inline-flex",
        }}
      >
        {label}
      </Typography>
      <Autocomplete
        options={options}
        fullWidth
        multiple={multiple}
        value={value || (multiple ? [] : null)} // Handle both single and multiple values
        PaperComponent={(props) => (
          <Paper {...props} sx={{ zIndex: 1300 }} />
        )}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.label}
              {...getTagProps({ index })}
              key={option.id}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <React.Fragment>
                  {startAdornment}
                  {params.InputProps?.startAdornment}
                </React.Fragment>
              ),
              endAdornment: (
                <React.Fragment>
                  {isLoading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps?.endAdornment}
                </React.Fragment>
              )
            }}
            error={error ? true : false}
            helperText={error}
          />
        )}
        {...rest}
      />
    </FormControl>
  );
};

const StyledSelect = styled(Select)(({ theme, height }) => ({
  "&:focus": {
    backgroundColor: "transparent",
  },
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

export default AppSelectInputApi;